/**
 *
 * @overview 基础组件
 * @author mll
 * @date 2019-8-20
 */

import CSSAnimate from './CSSAnimate';
import Icon from './Icon';
import Mask from './Mask';
import {NavBar, NavBarBase} from './NavBar';
import Pages, {Coming, P403, P404, P500, Result} from './Pages';
import {LeftSideBar, RightSideBar} from './SideBar';
import SideLayout from './SideLayout';
import SkinToolbox from './SkinToolbox';
import TopBar from './TopBar';

export {
  CSSAnimate,
  Icon,
  Mask,
  NavBar,
  NavBarBase,
  Pages, Coming, P403, P404, P500, Result,
  LeftSideBar, RightSideBar,
  SideLayout,
  SkinToolbox,
  TopBar,
};

export default {};
